<ng-template #IPchecking>{{ 'login-Page.checking' | translate }}</ng-template>

<div class="hub-wrapper container-fluid">    
    <div *ngIf="layout.isWeb$ | async" class="hub-body">
        <div class="top-horizontal-ad">
            <app-ad-container adType="TOP"></app-ad-container>
        </div>
        <div class="hub-container col-xxl-10 col-xl-10 col-lg-12 col-md-12">
            <div class="top-bar">
                <div class="top-bar-left">
                    {{ 'Home.welcome' | translate }}
                </div>
                <div class="top-bar-right">
                    <img src="assets/images/cps-logo-small.svg" (click)="goToCps()">
                    <button class="goToCpsButton" (click)="goToCps()">
                        {{ 'Home.gotocps' | translate }}
                    </button>
                </div>
            </div>
            <div class="hub-top-grid">
                <div class="hub-panel shortages">
                    <app-drug-shortages-panel></app-drug-shortages-panel>
                </div>
                <div class="hub-panel cpj">
                    <app-cpj-container></app-cpj-container>
                </div>
            </div>
            <div class="hub-mid-grid">
                <div class="hub-panel">
                    <app-practice-resources-panel></app-practice-resources-panel>
                </div>
                <div class="hub-panel edu">
                    <app-continuing-education-panel></app-continuing-education-panel>
                </div>
                <div class="top-vertical-ad">
                    <app-ad-container adType="SIDE"></app-ad-container>
                </div>
            </div>
            <div class="hub-bot-grid">
                <div class="hub-panel">
                    <app-events-panel></app-events-panel>
                </div>
                <div class="hub-panel">
                    <app-insights-panel></app-insights-panel>
                </div>
                <div class="hub-panel">
                    <app-contact-us></app-contact-us>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="layout.isTablet$ | async">
        <div class="top-horizontal-ad">
            <app-ad-container adType="TOP"></app-ad-container>
        </div>
        <div class="top-bar">
            <div class="top-bar-left">
                {{ 'Home.welcome' | translate }}
            </div>
            <div class="top-bar-right">
                <img src="assets/images/cps-logo-small.svg" (click)="goToCps()">
                <button class="goToCpsButton" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>
            </div>
        </div>
        <div class="hub-container">
            <div class="hub-top-grid">
                <div class="hub-panel shortages">
                    <app-drug-shortages-panel></app-drug-shortages-panel>
                </div>
                <div class="hub-panel cpj">
                    <app-cpj-container></app-cpj-container>
                </div>
            </div>
            <div class="hub-mid-grid">

                <div class="left">
                    
                    <div class="hub-panel edu-panel-tablet">
                        <app-continuing-education-panel></app-continuing-education-panel>
                    </div>                    
                    
                </div>
        
                <div class="right">
                    <div class="top-vertical-ad">
                        <app-ad-container adType="SIDE"></app-ad-container>
                    </div>    
                </div>
            </div>
            
            <div class="hub-mid-bot-grid">
                <div class="left">                    
                    <div class="hub-panel pr-panel-tablet">
                        <app-practice-resources-panel></app-practice-resources-panel>
                    </div>
                </div>
        
                <div class="right">
                    <div class="hub-panel">
                        <app-events-panel></app-events-panel>
                    </div>  
                </div>
            </div>
            <div class="hub-bot-grid">
                <div class="hub-panel">
                    <app-insights-panel></app-insights-panel>
                </div>  
                <div class="hub-panel">
                    <app-contact-us></app-contact-us>
                </div>              
            </div>
        </div>
    </div>

    <div *ngIf="layout.isHandset$ | async">
        <div class="top-bar">
            <div class="top-bar-left">
                {{ 'Home.welcome' | translate }}
            </div>
            <div class="top-bar-right">
                <img src="assets/images/cps-logo-small.svg" (click)="goToCps()">
                <button class="goToCpsButton" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>
            </div>
        </div>
        <div class="hub-mobile-container">
            <div class="hub-panel mobile-ad-top">
                <app-ad-container adType="MOBILE_TOP"></app-ad-container>
            </div>
 
            <div class="hub-panel">
                <app-drug-shortages-panel></app-drug-shortages-panel>
            </div>

            <div class="hub-panel">
                <app-cpj-container></app-cpj-container>
            </div>

            <div class="hub-panel mobile-ad-middle">
                <app-ad-container adType="MOBILE_MIDDLE"></app-ad-container>
            </div>
      
            <div class="hub-panel">
                <app-continuing-education-panel></app-continuing-education-panel>
            </div>
      
            <div class="hub-panel">
                <app-events-panel></app-events-panel>
            </div>
      
            <div class="hub-panel">
                <app-practice-resources-panel></app-practice-resources-panel>
            </div>
      
            <div class="hub-panel">
                <app-insights-panel></app-insights-panel>
            </div>
      
            <div class="hub-panel">
                <app-contact-us></app-contact-us>
            </div>
        </div>
    </div>
</div>

<app-build-version></app-build-version>